// frontend/src/components/parts/EditPart.js
// "Edit Part" -- renders the shared Part details form in edit mode.
import React from 'react';
import PartForm from './PartForm';

const EditPart = ({ part, onSuccess, onCancel }) => (
    <PartForm part={part} onSuccess={onSuccess} onCancel={onCancel} />
);

export default EditPart;
